import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
    Box,
    FormGroup,
    FormControlLabel,
    Switch,
    Tooltip,
    ClickAwayListener
  } from '@material-ui/core';
import HelpIcon from '../../Header/Icons/HelpIcon';
import IconButton from '@material-ui/core/IconButton';

const useStyles = makeStyles(theme => ({
    switchContainer: {
        marginLeft: 'auto',
        display: 'flex'
    },
    switchFormGroup: {
        flexDirection: 'row',
        position: 'relative',
        left: theme.spacing(1)
    },
    formControl: {
        marginRight: 0
    },
    helpIcon: {
      width: theme.spacing(2.25),
      height: theme.spacing(2.25),
      padding: theme.spacing(0),
      marginLeft: theme.spacing(0.5),
      '& svg': {
        padding: theme.spacing(0.25)
      }
    },
    tooltip: {
      padding: theme.spacing(0.3)
    }
}));

const SwitchFilter = (props)  => {
    const classes = useStyles();
    const [ isSwitchOn, setIsSwitchOn ] = useState(true);
    const [ currentlyFetching, setCurrentlyFetching ] = useState(false);
    const [ isTooltipOpen, setIsTooltipOpen ] = useState(false);
    const { handleChange } = props;

    const handleSwitchStatusChange = () => {
        if (!currentlyFetching) {
            setCurrentlyFetching(true);
            handleChange(isSwitchOn, () => setCurrentlyFetching(false));
            setIsSwitchOn(!isSwitchOn);
        }
    }

    return (
        <Box className={classes.switchContainer}>
            <FormGroup className={classes.switchFormGroup}>
                <FormControlLabel
                    control={<Switch checked={isSwitchOn} onChange={handleSwitchStatusChange} color="primary" />}
                    labelPlacement="end"
                    className={classes.formControl}
                />
            </FormGroup>
            <ClickAwayListener onClickAway={() => setIsTooltipOpen(false)}>
              <Tooltip
                title="Show Active Leads"
                open={isTooltipOpen}
                onClick={() => setIsTooltipOpen(true)}
                className={classes.tooltip}
              >
                <IconButton aria-label="delete">
                  <HelpIcon className={classes.helpIcon} />
                </IconButton>
              </Tooltip>
            </ClickAwayListener>
        </Box>
    )
}

export default SwitchFilter;
